var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#34366d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1159.891 8071.276)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(1160.891 -8070.276)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1168.645 -8062.823)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.707,
    y2: 10.707,
    transform: "translate(2.392 2.347)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 10.707,
    y2: 10.707,
    transform: "translate(2.392 2.347)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSign);
export default __webpack_public_path__ + "static/media/xSign.c12f49b892e05ae2b59dadbed869f4bd.svg";
export { ForwardRef as ReactComponent };